import { Button, Card } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';


const ListraTramitesMovil = (props) => {

    const { data, openModalMovil, openModalSolicitud, openDecisionModal, setModalBody, setModalTitle, setModalAccept, setModalCancel, } = props

    const bgDark = { backgroundColor: 'rgb(0,0,0,0.04)', fontWeight: 'bold' }
    const txtStyle = { padding: 2, textAlign: "center", }
    const classes = useStyles();

    return (
        <div className={classes.cardContainer}>
            {data.map((item, index) => {
                return (
                    <Card style={{ marginBottom: 10, }} key={index}>
                        <div style={{ backgroundColor: '#0064AC', color: 'white' }}>
                            <p style={txtStyle}>Folio</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.folio}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Reclamante / Solicitante</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.nombre_solicitante}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Fecha Ingreso</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.fecha_ingreso}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Tipo de trámite</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.tipo_reclamo}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Entidad requerida</p>
                        </div>
                        <div >
                            <p style={txtStyle}>{item.reclamado}</p>
                        </div>
                        <div style={bgDark}>
                            <p style={txtStyle}>Etapa actual</p>
                        </div>

                        {item.fase !== null ?
                            <div >
                                <p style={txtStyle}>{item.fase.nombre}</p>
                            </div>
                            :
                            null
                        }

                        <div >
                            {item.ux === 'gestion_externa' || item.ux === 'atencion_usuarios' ?
                                <Button style={{ width: '90%' }} variant='contained' onClick={() => {//cuando es solicitud
                                    openModalSolicitud(item)

                                }}>Ver</Button>
                                :
                                <Button style={{ width: '90%' }} variant='contained' onClick={() => {//cuando es trámite
                                    openModalMovil(item)

                                }}>Ver</Button>
                            }
                        </div>
                        <div style={{ marginTop: 5 }} >
                                    <Button style={{ width: '90%' }} variant='contained' onClick={() => {
                                        setModalBody('¿Desea dejar de monitorear éste trámite?')
                                        setModalTitle('Monitorear trámite')
                                        setModalAccept('Dejar de monitorear')
                                        setModalCancel('Cancelar')
                                        openDecisionModal(item)

                                    }}>Dejar de monitorear</Button>
                                </div>
                        <br></br>
                    </Card>
                )
            })}
            <br></br>
        </div>
    );
}

export default ListraTramitesMovil;

const useStyles = makeStyles((theme) => ({
    cardContainer: {
        width: 'inherit',
        minWidth: '100%',
        margin: 0,
        padding: 0,
        marginBottom: 10
    },
}));

